
<!-- 活动管理 -->
<template>
  <div id="mactivity">
    <button-router></button-router>

    <router-view v-slot="{ Component }">
      <!-- <keep-alive> -->
        <component :is="Component"></component>
      <!-- </keep-alive> -->
    </router-view>
  </div>
</template>

<style lang="scss" scoped>
#mactivity {
  height: 100%;
}
</style>
